// External URLs

export const LandtokenLogin = 'https://app.landtoken.io/login';
export const LandtokenSignUp = 'https://app.landtoken.io/signup';
export const LandtokenProjects = 'https://app.landtoken.io/projects';
